module.exports = __webpack_public_path__ + "img/referrals.c0a6fa96.png";